module.exports = __webpack_public_path__ + "images/0ad2f42d.www_3_group_cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/groupintro/www_3_group_cht.png
// module id = 626
// module chunks = 0